import { render, staticRenderFns } from "./Theatre.vue?vue&type=template&id=fc50c270&scoped=true&"
import script from "./Theatre.vue?vue&type=script&lang=js&"
export * from "./Theatre.vue?vue&type=script&lang=js&"
import style0 from "./Theatre.vue?vue&type=style&index=0&id=fc50c270&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc50c270",
  null
  
)

export default component.exports